export const MSGS = {
  KNOWLEDGE_BASE_ADD_SUCCESS: "Knowledge Base added successfully",
  KNOWLEDGE_BASE_UPDATE_SUCCESS: "Knowledge Base updated successfully",
};

export default MSGS;
